// @ts-strict-ignore
import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  HostBinding,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewContainerRef
} from '@angular/core';
import { SohoAccordionComponent, SohoAccordionHeaderComponent, SohoBusyIndicatorDirective } from 'ids-enterprise-ng';
import * as urltemplate from 'url-template';
import { Observable } from 'rxjs';

import { LMListContentBaseComponent } from './lm-list-content-base.component';
import { LMLoggerService } from '@services/lm-logger.service';
import { LMUrlUtilService } from '@services/utils/lm-url-util.service';
import { LMErrorUtilService } from '@services/utils/lm-error-util.service';
import { LMBusyIndicatorService } from '@services/lm-busyindicator.service';
import { LMCommonUtilService } from '@utils/lm-common-util.service';
import {
  LMListContentFilterListService,
  LMListContentFilterListUtilService,
  LMListEventService,
  LMListGridPagingService, LMListUtilService
} from './services/';
import { LMThemeService } from '@banner/lm-theme.service';
import { LMFormatUtilService } from '@services/utils';
import { LMConditionUtilService } from '@app/utils';

@Component({
  selector: 'lm-list-content-filterlist',
  standalone: false,
  templateUrl: './lm-list-content-filterlist.component.html',
  styleUrls: [ './lm-list-content-filterlist.component.scss' ],
  providers: [ LMListContentFilterListService ],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class LMListContentFilterListComponent extends LMListContentBaseComponent implements OnInit, AfterViewChecked, LMListContentInterface {

  @ViewChild(SohoBusyIndicatorDirective, { static: true }) sohoBusyIndicator: SohoBusyIndicatorDirective;
  @ViewChild(SohoAccordionComponent, { static: true }) sohoAccordionComponent: SohoAccordionComponent;
  @ViewChildren('AccordionHeader') accordionHeaders: QueryList<SohoAccordionHeaderComponent>;
  @ViewChild('dialogPlaceholder', { read: ViewContainerRef, static: true }) placeholder: ViewContainerRef;

  @HostBinding('id') get filterListId() {
    return this?.listSpec?.busListSpec?.id + '_filterlist';
  }

  @HostBinding('attr.data-automation-id') get filterListAutomationId() {
    if (!this?.listSpec?.busListSpec?.automationId) {
      return null;
    }
    return `lm-${this.listSpec.busListSpec.automationId}-filterlist`;
  }

  public filterListTemplateData: Array<LMFilterListTemplateData>;
  public dataViewSet: LMDataViewSet = null;
  private pageSize = -1;
  private fFromDataViewChanged = false;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    protected lmLoggerService: LMLoggerService,
    protected lmThemeService: LMThemeService,
    protected lmFormatUtilService: LMFormatUtilService,
    protected lmConditionUtilService: LMConditionUtilService,
    protected lmListUtilService: LMListUtilService,

    private lmBusyIndicatorService: LMBusyIndicatorService,
    private lmCommonUtilService: LMCommonUtilService,
    private lmErrorUtilService: LMErrorUtilService,
    private lmFilterListService: LMListContentFilterListService,
    private lmListContentFilterListUtilService: LMListContentFilterListUtilService,
    private lmListEventService: LMListEventService,
    private lmListGridPagingService: LMListGridPagingService,
    private lmUrlUtilService: LMUrlUtilService
  ) {
    super(lmLoggerService, lmThemeService, lmFormatUtilService, lmListUtilService, lmConditionUtilService);
  }

  ngOnInit() {
    this.clearEmptyMessage();
  }
  ngAfterViewChecked() {
    if (this.fFromDataViewChanged) {
      this.fFromDataViewChanged = false;
      setTimeout(() => this.buildFilterList());
    }
  }
  /**
   * There is nothing to build at this point. Filter lists must
   * have a fromDataView to load data.
   */
  public build() { }

  protected loadManualData(): void {
    // Not implemented
  }

  protected onFormButtonClicked(columnDef: ListGridColumn, dataView: LMDataView, row: any, cell: any, navigationParams: any, event: any): void {
    // Not implemented
  }

  public onContextMenuItemSelected(actionReference: LMBusActionReference, selectedDataView?: LMDataView): void {
    // TODO
  }

  protected fromDataViewChanged() {
    if (this.listSpec.dependentList) {
      // Protect against a filter list being defined with implements manual loading
      this.allowDataLoading = true;
    }
    this.fFromDataViewChanged = true;
    this.changeDetectorRef.markForCheck();
  }

  /**
   * Required abstract method - NOOP impl is fine
   * for filter-list since it's unlikely we will allow users to filter
   * the filter list.
   */
  protected filterCriteriaChanged() { }

  /**
   * Required abstract method - NOOP impl is fine for filter-list
   * since it's unlikely we will allow users to apply filterListCrteria
   * to a filter-list.
   */
  protected filterListCriteriaChanged() { }

  protected reportAsOfDateChanged(): void {
    //noop
  }

  public getSelectedRow(): number {
    if (!this.sohoAccordionComponent) {
      return -1;
    }

    const selectedAccordionHeader = this.accordionHeaders.find(header =>
      header.elementRef.nativeElement.classList.contains('is-selected'));

    if (!selectedAccordionHeader) {
      return -1;
    }

    return Number(selectedAccordionHeader.elementRef.nativeElement.dataset.index);
  }

  public getSelectedRows(): Array<number> {
    return [ this.getSelectedRow() ];
  }

  public setSelectedRow(row: number, scrollIntoView = true): void {
    if (!this.sohoAccordionComponent) {
      return;
    }

    if (row === -1) {
      this.fireListRowSelectedEvent(-1, null, event);
      return;
    }

    const selectedAccordionHeader = this.accordionHeaders.find(header => {
      const index = Number(header.elementRef.nativeElement.dataset.index);
      return (row === index);
    });

    this.unSelectAllRows();

    const selectedElement = selectedAccordionHeader.elementRef.nativeElement;
    selectedElement.classList.add('is-selected');

    if (scrollIntoView) {
      this.lmCommonUtilService.scrollIntoView(selectedElement);
    }

    setTimeout(() => {
      const selectedRow = Number(selectedElement.dataset.index);

      // const selRow = this.getSelectedRow();
      // this.sohoAccordionComponent.updated();
      // this.sohoAccordionComponent.expandAll();
      // this.setSelectedRow(selRow, true);

      this.fireListRowSelectedEvent(selectedRow, selectedElement, event);
    }, 1);
  }

  public setSelectedRows(rows: Array<number>, scrollIntoView = true): void {
    if (this.dataViewSet && this.dataViewSet.data && this.dataViewSet.data.length > 0) {
      this.setSelectedRow(rows[0]);
    } else {
      this.setSelectedRow(-1);
    }
  }

  public unSelectAllRows(): void {
    if (this.sohoAccordionComponent) {
      this.sohoAccordionComponent.headers.forEach(header =>
        header.elementRef.nativeElement.classList.remove('is-selected'));
    }
  }

  public onSelected(event: Event) {
    setTimeout(() => {
      // ----------------------------------------------------------
      // SetTimeout in order to allow SOHO process to finish
      // updating the DOM with new selection
      // ----------------------------------------------------------
      const targetElement: HTMLElement = event.currentTarget as HTMLElement;
      const headerElement: HTMLElement = targetElement.getElementsByClassName('is-selected')[0] as HTMLElement;
      if (headerElement.dataset.index === undefined) {
        // ----------------------------------------------------------
        // Return if header is a grouped header
        // ----------------------------------------------------------
        return;
      }

      const selectedRow = Number(headerElement.dataset.index);
      this.fireListRowSelectedEvent(selectedRow, headerElement, event);
    }, 1);
  }

  private fireListRowSelectedEvent(idx: number, elem: HTMLElement, event?: any) {
    const data = this.dataViewSet ? this.dataViewSet.data[idx] : null; // safety
    const listRowSelectedEvent: LMListRowSelectedEvent = {
      event,
      rows: [ { idx, data, elem } ]
    };
    this.lmListEventService.listRowSelectedEvent(listRowSelectedEvent);
  }

  private buildFilterList() {
    // console.log('listfilter buildFilterList');
    if (!this.listSpec.dependentList) {
      throw 'filter list must be a dependent list.';
    }

    if (!this.fromDataView) {
      setTimeout(() => this.lmListEventService.dataLoadedEvent(null));
      return;
    }

    const url = this.buildInitialPageUrl();
    const postContent = this.lmUrlUtilService.buildSelectDataViewPagingRequest(this.selectRequestData);

    this.lmListEventService.busyIndicatorDisplayedEvent({ show: true });
    // -1 means get all records for the filter list.
    this.lmListGridPagingService.initialPage(url, -1, postContent).subscribe(
      (listPagingResponse: LMListPagingResponse) => {
        this.setEmptyMessage();

        this.lmListEventService.busyIndicatorDisplayedEvent({ show: false });
        if (listPagingResponse.status === 'COMPLETED') {
          this.postInitialLoad(listPagingResponse);
          return;
        }

        if (listPagingResponse.status === 'SYSTEM_EXCEPTION') {
          this.lmErrorUtilService.handleError(listPagingResponse.statusText, listPagingResponse.details, listPagingResponse.status);
          return;
        }

      },
      err => {
        this.lmListEventService.busyIndicatorDisplayedEvent({ show: false });
        this.lmErrorUtilService.handleUnexpectedError(err, this.placeholder);
      });
  }

  private buildInitialPageUrl(): string {
    if (this.listState
      && this.listState.currentPageUrl
      && this.fromDataView.resourceId === this.listState.fromResourceId
      && this.lmUrlUtilService.allCsksMatchContext(this.listState.currentPageUrl)
    ) {
      // ------------------------------------------------------------------
      // if the fromDataView hasn't changed and there is a currentPageUrl
      // then load that to keep our position in the dependent list.
      // ------------------------------------------------------------------
      return this.listState.currentPageUrl;
    } else {
      // ------------------------------------------------------------------
      // else resolve template against the fromDataView's resourceId
      // ------------------------------------------------------------------
      const compiledUrlTemplate = urltemplate.parse(this.listUrlInfo.initialDataUrl);
      return compiledUrlTemplate.expand({ resourceId: this.fromDataView.resourceId });
    }
  }

  private postInitialLoad(listPagingResponse: LMListPagingResponse) {

    this.dataViewSet = listPagingResponse.dataViewSet;
    this.filterListTemplateData = this.lmFilterListService.getFilterListTemplateData(this.dataViewSet, this.listSpec.groupLabel);
    this.pageSize = this.dataViewSet.pagingInfo.pageSize;

    /**
     * fire dataLoaded event once listview has been initially loaded with data.
     * Do not fire for any other paging requests other than 'initialPage' load.
     */
    setTimeout(() => {
      if (this.sohoAccordionComponent) {
        // -----------------------------------------------------------------
        // expand the accordion before making any selection.
        // todo ppatton keep track of expanded state in session storage.
        // -----------------------------------------------------------------
        this.sohoAccordionComponent.updated();
        this.sohoAccordionComponent.expandAll();
      }
    });
    setTimeout(() => {
      this.lmListEventService.dataLoadedEvent(listPagingResponse);

      // this code below causes a 2nd selection event which tries to load the
      // filter list target twice.
      // if (this.sohoAccordionComponent) {
      //   // soho updated loses track of what is selected, so save off what is
      //   // selected and reselect
      //   const selRow = this.getSelectedRow();
      //   this.sohoAccordionComponent.updated();
      //   this.sohoAccordionComponent.expandAll();
      //   this.setSelectedRow(selRow, true);
      // }
    });
  }

  public refresh(): Observable<any> {
    return new Observable<any>(observer => {
      this.lmListEventService.busyIndicatorDisplayedEvent({ show: true });
      // console.log('listfilter reload');
      const postContent = this.lmUrlUtilService.buildSelectDataViewPagingRequest(this.selectRequestData);

      // request the first page of records and log how long it took
      this.lmLoggerService.time({ id: 'reload-page' });
      this.lmListGridPagingService.reloadPage(this.dataViewSet, -1, postContent).subscribe((listPagingResponse: LMListPagingResponse) => {
        this.lmLoggerService.timeEnd('reload-page', [ this, listPagingResponse.dataViewSet ]);
        this.lmListEventService.busyIndicatorDisplayedEvent({ show: false });
        this.postInitialLoad(listPagingResponse);
        observer.next(true);
        observer.complete();
      });
    });
  }

  // noop functions
  public updateDataView(key: number, dataView: LMDataView): void { }

  public updateDataViewTransaction(key: number, status: string, message: string): void { }

  public getDirtyRows(): Array<LMDataView> {
    return [];
  }

  public activatedRow(): number {
    return 0;
  }

  public activateRow(row: number, scrollIntoView = true): void { }

  public isModified(): boolean {
    return false;
  }

  public addDataView(dataView: LMDataView, index: number) { }

  public removeDataView(index: number) { }

  public setDirtyIndicator(row: number, cell: number, showDirty: boolean) { }

  onDrop(event: DragEvent) {
    const target = event.srcElement as HTMLElement;
    const header = target.closest('.accordion-header') as HTMLElement;
    const filterRow = Number(header.dataset.index);

    setTimeout(() => {
      header.style.borderStyle = 'solid';
      header.style.borderWidth = '1px';
      header.style.borderColor = '#d8d8d8';
    }, 1);

    const row = Number(event.dataTransfer.getData('text'));
    this.lmListContentFilterListUtilService.emitCardDrop(row, filterRow);
  }

  onDragOver(event: DragEvent) {
    const target = event.srcElement as HTMLElement;

    const header: HTMLElement = target.closest('.accordion-header') as HTMLElement;
    // let index = header.dataset.index;

    header.style.borderWidth = '2px';
    header.style.borderStyle = 'dashed';
    header.style.borderColor = 'black';

    return false;
  }

  onDragStart(event: DragEvent) {
    event.preventDefault();

    return false;
  }

  onDragLeave(event: DragEvent) {
    const target = event.srcElement as HTMLElement;

    const header: HTMLElement = target.closest('.accordion-header') as HTMLElement;
    const index = header.dataset.index;

    const selectedAccordionHeader = this.accordionHeaders.toArray()[index];
    header.style.borderStyle = 'solid';
    header.style.borderWidth = '1px';
    header.style.borderColor = '#d8d8d8';
  }

  setEmptyMessage(clear = false) {
    if (clear) {
      this.clearEmptyMessage();
    } else {
      this.setNoDataMessage(this.filterCriteria && this.filterCriteria.length > 0);
    }
  }
}
